<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-lg-4">
      <section class="card" style="margin-top: 30px">
        <form class="p-5" id="myCat">
          <div class="col-md-12">
            <label class="form-label">نام</label>
            <input type="text" class="form-control" v-model="users.name">
          </div>
          <div class="col-md-12">
            <label class="form-label">ایمیل</label>
            <input type="text" class="form-control" v-model="users.email">
          </div>
          <div class="col-md-12">
            <label class="form-label">رمز ورود</label>
            <input type="text" class="form-control" v-model="users.password">
          </div>

          <div class="col-md-12">
            <label class="form-label"> سطح دسترسی را تعیین کنید</label>
            <select v-model="users.roles" class="form-control">
              <option value="admin">مدیر</option>
              <option value="user">کاربر</option>
            </select>
          </div>
          <div class="col-md-12">
            <br>
            <btn_loading  v-if="loading" ></btn_loading>
            <button type="button"  v-elseif="loading=='false'"  v-if="status =='true'" class="btn btn-success form-control"
                    @click="btn_create()"> ثبت
            </button>
            <button type="reset"  v-elseif="loading=='false'"   v-else class="btn btn-danger form-control" @click="btn_update()">
              به روز رسانی
            </button>
          </div>
        </form>
      </section>
    </div>
    <div class="col-lg-7 card ">
      <table class="table table-bordered p-2">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">نام</th>
          <th scope="col">ایمیل</th>
          <th scope="col">نقش</th>
          <th scope="col">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for=" (list , index) in listUsers">

          <td>{{ index + 1}}</td>
          <td>{{ list.name }}</td>
          <td>{{ list.email }}</td>
          <td>{{ (list.roles[0]) ? (list.roles[0].permission === "admin") ? "مدیر" : "کاربر" : "" }}</td>
          <td>
            <a href="#">
              <i class="fa fa-trash" @click="btn_del(list.id)"></i>
            </a>
            |
            <a href="#">
              <i class="fa fa-edit" @click="btn_edit(list.id ,list.name ,list.email)"></i>
            </a>
          </td>
        </tr>
        <tr>
          <td colspan="10">
            <nav class="text-danger">
              <ul class="pagination  " style="justify-content: center;">
                <li class="page-item">
                  <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                          v-on:click="foreachPaginateUsers(paginatetion.first_page_url)" title="اولین"><i
                      class="fa fa-angle-double-right"></i></button>
                  <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                          v-on:click="foreachPaginateUsers(paginatetion.prev_page_url)" title="قبلی"><i
                      class="fa fa-angle-right"></i></button>
                </li>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <li class="page-item">
                  <button class="btn btn-light" v-on:click="foreachPaginateUsers(paginatetion.next_page_url)"
                          :disabled="!paginatetion.next_page_url" title="بعدی">
                    <i class="fa fa-angle-left"></i></button>

                  <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                          v-on:click="foreachPaginateUsers(paginatetion.last_page_url)" title="اخرین"><i
                      class="fa fa-angle-double-left"></i></button>
                </li>
              </ul>
            </nav>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import config from "../../../../config/config.json";
import {useToast} from "vue-toastification";
import {list} from "postcss";
import Btn_loading from "@/common/components/btn_loading.vue";
export default {
  name: "index",
  components: {Btn_loading},
  computed: {
    list() {
      return list
    }
  },
  data() {
    return {
      status: 'true',
      loading:false,
      btn_insert: true,
      btn_up: false,
      user_id: "",
      listUsers: [],
      paginatetion: {},
      url: `${config.BASE_URL}/users`,
      password: "",
      users: {
        id: "",
        name: '',
        email: '',
        password: '',
        roles: ''
      }
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      let self = this;
      self.axios.get(self.url)
          .then(function (res) {
            if (res.data.status) {
              self.listUsers = res.data.data.data;
              self.makePaginatetion(res.data.data);
            }
          })
          .catch(function (errors) {
          });
    },
    btn_edit(id, name, email) {
      let self = this;
      self.status = 'false';
      self.users.id = id;
      self.users.email = email;
      self.users.name = name;
    },
    btn_update: function () {
      let self = this;
      self.loading=true;
      const toast = useToast();
      let formData = new FormData();
      formData.append('id', self.users.id);
      formData.append('name', self.users.name);
      formData.append('email', self.users.email);
      formData.append('password', self.users.password);
      formData.append('roles', self.users.roles);
      self.axios.post(self.url + '/update', formData).then(function (res) {
        self.loading=false;
        if (res.data.status === 'true') {
          self.users.name = " ";
          self.users.email = " ";
          self.users.password = " "
          self.getUsers();
          self.status = 'true';
          toast.success(res.data.messages);
          return "";
        }
      })
          .catch(function (errors) {
            self.loading=false;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },
    btn_create: function () {
      let self = this;
      self.loading=true;
      const toast = useToast();
      let formData = new FormData();
      formData.append('name', self.users.name);
      formData.append('email', self.users.email);
      formData.append('password', self.users.password);
      formData.append('roles', self.users.roles);
      self.axios.post(self.url, formData).then(function (res) {
        self.loading=false;
        if (res.data.status === 'true') {
          self.users.name = " ";
          self.users.email = " ";
          self.users.password = " "
          self.getUsers();
          toast.success(res.data.messages);
          return "";
        }
      })
          .catch(function (errors) {
            self.loading=false;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },
    btn_del(id) {
      let self = this
      const toast = useToast();
      self.axios.get(`${self.url}/delete/${id}`)
          .then(function (response) {
            self.getUsers()
            return toast.success(response.data.messages);
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              Object.values(error.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (error.response.status === 404) {
              toast.error(error.response.data.messages);
            }

          });
    },
    makePaginatetion(data) {
      let self = this;
      let paginatetion = {
        current_page: data.current_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        first_page_url: data.first_page_url
      }
      self.paginatetion = paginatetion;
    },
    foreachPaginateUsers(url) {
      let self = this;
      self.url = url;
      self.getUsers()
    },
  }
}
</script>
